import { useNavigate } from "react-router-dom";
import { getBook } from "../data/books";
import { getModel } from "../data/models";
import { BookCover } from "../components/BookCover";
import { useApp } from "../context/AppContext";
import { centsToDollars, computeTotals } from "@shared/pricing";

export function CartPage() {
  const { go, cart, removeFromCart } = useApp();
  const navigate = useNavigate();
  const totals = computeTotals(cart);

  return (
    <main className="cart-page">
      <div className="wrap">
        <h1>
          Your <span className="it">cart.</span>
        </h1>
        {cart.length === 0 ? (
          <div className="cart-empty">
            <p>The cart is quiet for now.</p>
            <button className="btn btn-rust" onClick={() => go({ name: "home" })}>
              Browse the collection →
            </button>
          </div>
        ) : (
          <div className="cart-grid">
            <div>
              {cart.map((item) => {
                const book = getBook(item.bookId);
                const model = getModel(item.modelId);
                if (!book) return null;
                return (
                  <div key={item.id} className="cart-item">
                    <div className="thumb">
                      <div className="cover">
                        <BookCover book={book} name={item.name} model={model} />
                      </div>
                    </div>
                    <div className="info">
                      <h3>
                        <span
                          style={{ display: "block", color: "var(--ink-soft)", fontSize: 14, letterSpacing: "0.02em" }}
                        >
                          {item.name} {book.namePrefix}
                        </span>
                        <span className="it">{book.titleSecond}</span>
                      </h3>
                      <dl>
                        <dt>For</dt>
                        <dd>{item.name}</dd>
                        <dt>Pronouns</dt>
                        <dd>{item.gender === "boy" ? "He / Him" : item.gender === "girl" ? "She / Her" : "They / Them"}</dd>
                        <dt>Character</dt>
                        <dd>As pictured</dd>
                        <dt>From</dt>
                        <dd>{item.signature}</dd>
                        <dt>Format</dt>
                        <dd>{item.formatName}</dd>
                      </dl>
                      <div className="actions">
                        <button
                          onClick={() =>
                            navigate(`/personalize/${encodeURIComponent(book.id)}`, {
                              state: { editItemId: item.id, editItem: item },
                            })
                          }
                        >
                          Edit
                        </button>
                        <button onClick={() => removeFromCart(item.id)}>Remove</button>
                      </div>
                    </div>
                    <div className="price">${centsToDollars(item.priceCents)}</div>
                  </div>
                );
              })}
              <div
                style={{
                  marginTop: 24,
                  fontFamily: "var(--mono)",
                  fontSize: 12,
                  color: "var(--ink-soft)",
                  letterSpacing: "0.1em",
                }}
              >
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    go({ name: "home" });
                  }}
                  className="link-u"
                >
                  ← Keep browsing
                </a>
              </div>
            </div>

            <div className="cart-summary">
              <h2>Order summary</h2>
              <div className="row">
                <span>Subtotal</span>
                <span>${centsToDollars(totals.subtotalCents)}</span>
              </div>
              <div className="row">
                <span>Shipping</span>
                <span>{totals.shippingCents === 0 ? "Free" : `$${centsToDollars(totals.shippingCents)}`}</span>
              </div>
              <div className="row">
                <span>Estimated tax</span>
                <span>${centsToDollars(totals.taxCents)}</span>
              </div>
              <div className="row total">
                <span>Total</span>
                <b>${centsToDollars(totals.totalCents)}</b>
              </div>
              <button className="btn btn-rust big" onClick={() => go({ name: "checkout" })}>
                Checkout <span className="arr">→</span>
              </button>
              <div
                style={{
                  marginTop: 16,
                  fontFamily: "var(--mono)",
                  fontSize: 11,
                  color: "var(--ink-soft)",
                  letterSpacing: "0.1em",
                  textAlign: "center",
                }}
              >
                FREE SHIPPING ON ORDERS OVER $40
              </div>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}
